/**
 * PlantApi
 * 1.0
 * DO NOT MODIFY - This file has been generated using oazapfts.
 * See https://www.npmjs.com/package/oazapfts
 */
import * as Oazapfts from "oazapfts/lib/runtime";
import * as QS from "oazapfts/lib/runtime/query";
export const defaults: Oazapfts.Defaults<Oazapfts.CustomHeaders> = {
    headers: {},
    baseUrl: "/",
};
const oazapfts = Oazapfts.runtime(defaults);
export const servers = {};
export type AcceptInviteDto = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    passwordConfirmation: string;
    inviteToken: string;
};
export type DataStatus = "success" | "notValid" | "exception" | "error" | "inUse" | "notFound" | "noChange" | "inProgress" | "invalidPage" | "notAuthorized" | "duplicateEntity" | "noContent" | "accepted";
export type ErrorResponse = {
    message: string;
    kind: DataStatus;
    exception?: string | null;
    stackTrace?: string | null;
    exceptionType?: string | null;
    innerException?: string | null;
    validationErrors?: {
        [key: string]: string[];
    } | null;
};
export type ValidationProblemDetails = {
    "type"?: string | null;
    title?: string | null;
    status?: number | null;
    detail?: string | null;
    instance?: string | null;
    errors: {
        [key: string]: string[];
    };
    [key: string]: any;
};
export type NewUserDto = {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
    passwordConfirmation: string;
    organization: string;
    industryId: number;
    subscriptionId?: number | null;
    organizationId: number;
};
export type UserModel = {
    userName: string;
    mobileUserName: string;
    email: string;
    firstName: string;
    lastName: string;
    userId: number;
    organizationId: number;
    isValidForPlant: boolean;
};
export type UserTypeDto = {
    userTypeId: number;
    userTypeName: string;
};
export type InvitedUserDto = {
    firstName: string;
    lastName: string;
    email: string;
    userTypeId: number;
    organizationName: string;
    inviteToken: string;
};
export type UserInviteStatus = "invited" | "accepted";
export type OrganizationUserDto = {
    firstName: string;
    lastName: string;
    email: string;
    ckSetupUserType: UserTypeDto;
    organizationName: string;
    inviteTokenExpiration?: string | null;
    inviteToken: string;
    userInviteStatus: UserInviteStatus;
    empcode?: number | null;
};
export type OrganizationUserDtoListResultSet = {
    totalResults: number;
    totalPages: number;
    currentPage: number;
    pageSize: number;
    previousUrl?: string | null;
    nextUrl?: string | null;
    filter?: any | null;
    data?: OrganizationUserDto[] | null;
};
export type PlantInfo = {
    plantId: number;
    plantName: string;
    plantNumber: string;
    licenseName: string;
    licenseId: number;
};
export type ForgotPasswordDto = {
    appName: string;
    email: string;
};
export type UnifiedLoginIssueTicketRequest = {
    appName: string;
    targetApp: string;
};
export type UnifiedLoginIssueTicketResponse = {
    ticketId: string;
    expiresAt: string;
    redirectUrl?: string | null;
};
export type UnifiedLoginRedeemTicketRequest = {
    appName: string;
    ticketId: string;
};
export type UnifiedLoginRedeemTicketResponse = {
    entraObjectId: string;
    email: string;
    displayName: string;
    organizationId: string;
    role: string;
    canEnableApps: boolean;
    tokenType: string;
    accessToken: string;
    expiresIn: number;
};
export function acceptInvite(acceptInviteDto: AcceptInviteDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/invite/accept", oazapfts.json({
        ...opts,
        method: "POST",
        body: acceptInviteDto
    }));
}
export function createUser(newUserDto: NewUserDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserModel;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user", oazapfts.json({
        ...opts,
        method: "POST",
        body: newUserDto
    }));
}
export function getUser(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserModel;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user", {
        ...opts
    });
}
export function deleteInvitation(inviteToken: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/user/invite/${encodeURIComponent(inviteToken)}`, {
        ...opts,
        method: "DELETE"
    });
}
export function getCkSetupUserTypes(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UserTypeDto[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/invite/cksetupusertypelookuplist", {
        ...opts
    });
}
export function inviteUserToOrganization(invitedUserDto: InvitedUserDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/invite", oazapfts.json({
        ...opts,
        method: "POST",
        body: invitedUserDto
    }));
}
/**
 * ** Required Pagination Parameters **
 */
export function geInviteList({ page, pageSize }: {
    page?: number;
    pageSize?: number;
} = {}, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: OrganizationUserDtoListResultSet;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/user/invite${QS.query(QS.explode({
        page,
        pageSize
    }))}`, {
        ...opts
    });
}
export function getUserPlantList(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: PlantInfo[];
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/plants", {
        ...opts
    });
}
export function resendInvitation(inviteToken: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/user/invite/resend/${encodeURIComponent(inviteToken)}`, {
        ...opts,
        method: "PUT"
    });
}
export function attachEmployeeToUser(userId: number, employeeCode: number, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/user/${encodeURIComponent(userId)}/attachEmployee/${encodeURIComponent(employeeCode)}`, {
        ...opts,
        method: "PATCH"
    });
}
export function forgotPassword(forgotPasswordDto: ForgotPasswordDto, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: boolean;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/forgotPassword", oazapfts.json({
        ...opts,
        method: "POST",
        body: forgotPasswordDto
    }));
}
export function issueUnifiedLoginTicket(unifiedLoginIssueTicketRequest: UnifiedLoginIssueTicketRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UnifiedLoginIssueTicketResponse;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/tickets/issue", oazapfts.json({
        ...opts,
        method: "POST",
        body: unifiedLoginIssueTicketRequest
    }));
}
export function redeemUnifiedLoginTicket(unifiedLoginRedeemTicketRequest: UnifiedLoginRedeemTicketRequest, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: UnifiedLoginRedeemTicketResponse;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 422;
        data: ValidationProblemDetails;
    } | {
        status: 500;
        data: ErrorResponse;
    }>("/api/user/tickets/redeem", oazapfts.json({
        ...opts,
        method: "POST",
        body: unifiedLoginRedeemTicketRequest
    }));
}
export function verifyInviteToken(inviteToken: string, opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchJson<{
        status: 200;
        data: NewUserDto;
    } | {
        status: 400;
        data: ErrorResponse;
    } | {
        status: 401;
    } | {
        status: 404;
        data: ErrorResponse;
    } | {
        status: 500;
        data: ErrorResponse;
    }>(`/api/user/invite/verify/${encodeURIComponent(inviteToken)}`, {
        ...opts
    });
}
export function postApiReportLabelTestpdf(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/report/label/testpdf", {
        ...opts,
        method: "POST"
    });
}
export function getApiReportTestbulk(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/report/testbulk", {
        ...opts
    });
}
export function getApiReportTrainingLog(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/report/training/log", {
        ...opts
    });
}
export function getApiReportSupervisorscorecard(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/report/supervisorscorecard", {
        ...opts
    });
}
export function getApiReportInspectionhistory(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/report/inspectionhistory", {
        ...opts
    });
}
export function getApiReportEmployeeSkill(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/report/employee/skill", {
        ...opts
    });
}
export function getApiDevtestsTest(opts?: Oazapfts.RequestOpts) {
    return oazapfts.fetchText("/api/devtests/test", {
        ...opts
    });
}
